module.exports = __webpack_public_path__ + "img/portrait-080.01dd395f.jpg";